module.exports = __webpack_public_path__ + "static/media/user-graduate.0266502b.svg";